import { createAction, props } from '@ngrx/store';

const GET_WIZARD_STEP = '[Generations] Get Wizard Step';
const NAVIGATE_WIZARD_STEP = '[Generations] Navigate Wizard Step';
const GENERATE_WIZARD_STEP = '[Generations] Generate Wizard Step';
const GENERATE_WIZARD_STEP_SUCCESS = '[Generations] Generate Wizard Step Success';
const SET_WIZARD_STEP_SUCCESS = '[Generations] Set Wizard Step';
const SET_WIZARD_STEP_FAILURE = '[Generations] Set Wizard Step Failure';
const CLEAR_WIZARD_LOGS = '[Generations] Clear Wizard Logs';

const getWizardStep = createAction(GET_WIZARD_STEP, props<{ apiConstants: any }>());
const navigateWizardStep = createAction(
  NAVIGATE_WIZARD_STEP,
  props<{ apiConstants: any; urlPathVariables: { generationId: string } }>()
);
const generateWizardStep = createAction(
  GENERATE_WIZARD_STEP,
  props<{
    apiConstants: any;
    payloadWithPathVariables: {
      generationId: string;
      componentType: string;
      userPrompt: string;
      page_id?: string;
      removeUrlVariables: string[];
    };
  }>()
);
const generateWizardStepSuccess = createAction(
  GENERATE_WIZARD_STEP_SUCCESS,
  props<{ generationId: string }>()
);
const setWizardStepSuccess = createAction(SET_WIZARD_STEP_SUCCESS);
const setWizardStepFailure = createAction(SET_WIZARD_STEP_FAILURE, props<{ error: any }>());
const clearWizardLogs = createAction(CLEAR_WIZARD_LOGS);

export const WizardStepActions = {
  getWizardStep,
  navigateWizardStep,
  generateWizardStep,
  generateWizardStepSuccess,
  setWizardStepSuccess,
  setWizardStepFailure,
  clearWizardLogs
};
